import React, { Component } from "react";
import {
  Typography,
  Paper,
  Divider,
  Select,
  Checkbox,
  TextField,
  Grid,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import shortfetch from "../../../components/data/fetch";

class Features extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,

      filter: this.props.state.filter,
    };
  }

  async fetch_data(id) {
    let post_json = {
      id: id,
      type: "model_data",
      auth: localStorage.getItem("auth"),
    };

    let data = await shortfetch(post_json);

    // console.log(data);

    this.setState({
      select_items_list: data,
      isLoading: false,
    });
  }

  componentDidMount() {
    this.fetch_data(1);
  }

  render() {
    if (this.state.isLoading) {
      return "";
    }

    return (
      <React.Fragment>
        <Paper style={{ padding: 5, width: "100%" }}>
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="stretch"
          >
            <Grid item>
              <h2>Filter</h2>
              <Divider />
            </Grid>
            <Grid item container justify="space-between" alignItems="center">
              <Grid item xs={5}>
                <Typography component={"span"}>Fabrikant:</Typography>
              </Grid>
              <Grid item xs={7} container justify="center" alignItems="center">
                <Autocomplete
                  value={this.state.select_items_list["Fabrikanten"].find(
                    (item) => {
                      if (item.value == this.state.filter.Fabrikant) {
                        return item;
                      }
                    }
                  )}
                  options={this.state.select_items_list["Fabrikanten"]}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => <TextField {...params} />}
                  onChange={(e, value) => {
                    if (value != null) {
                      this.state.filter.Fabrikant = value.value;
                    } else {
                      this.state.filter.Fabrikant = 0;
                    }

                    this.props.Filter_Update(this.state.filter);
                  }}
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Divider />
            <Grid item container justify="space-between" alignItems="center">
              <Grid item xs={5}>
                <Typography component={"span"}>Type:</Typography>
              </Grid>
              <Grid item xs={7} container justify="center" alignItems="center">
                <Autocomplete
                  value={this.state.select_items_list["Type"].find((item) => {
                    if (item.value == this.state.filter.Type) {
                      return item;
                    }
                  })}
                  options={this.state.select_items_list["Type"]}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => <TextField {...params} />}
                  onChange={(e, value) => {
                    if (value != null) {
                      this.state.filter.Type = value.value;
                    } else {
                      this.state.filter.Type = 0;
                    }

                    this.props.Filter_Update(this.state.filter);
                  }}
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

export default Features;
